/** @format */

import {ActiveOrdersContext, activeOrdersDefaultState} from './active_orders_context';
import React, {useState, useEffect} from 'react';
import update from 'immutability-helper';
import SuperAgent from 'superagent';

function ActiveOrdersContextProvider({children}) {
    const [state, setState] = useState(activeOrdersDefaultState);

    function handleUpdateProof(cartId, orderId, proofId, proof) {
        const cartIndex = state.carts.findIndex(cart => cart.id == cartId);
        const orderIndex = state.carts[cartIndex].orders.findIndex(order => order.id == orderId);

        if (orderIndex != -1) {
            const proofIndex = state.carts[cartIndex].orders[orderIndex].proofs.findIndex(
                proof => proof.id == proofId
            );

            const updateTarget = {
                carts: {
                    [cartIndex]: {
                        orders: {
                            [orderIndex]: {
                                status_id: {
                                    $set: proof.order.status_id
                                },
                                external_status_label: {
                                    $set: proof.order.external_status_label
                                },
                                latest_proof_status_id: {
                                    $set: proof.order.latest_proof_status_id
                                },
                                latest_proof_status_label: {
                                    $set: proof.order.latest_proof_status_label
                                },
                                latest_proof_status_icon: {
                                    $set: proof.order.latest_proof_status_icon
                                },
                                latest_proof_status_class: {
                                    $set: proof.order.latest_proof_status_class
                                },
                                latest_proof_internal_status_id: {
                                    $set: proof.order.latest_proof_internal_status_id
                                },
                                latest_proof_internal_status_label: {
                                    $set: proof.order.latest_proof_internal_status_label
                                },
                                status_icon: {$set: proof.order.status_icon},
                                proofs: {$splice: [[proofIndex, 1, proof]]}
                            }
                        }
                    }
                }
            };

            setState(update(state, updateTarget));
        }
    }

    useEffect(() => {
        SuperAgent.get('/account/orders/index')
            .set('accept', 'application/json')
            .end((err, response) => {
                setState({
                    loading: false,
                    carts: response.body.activeOrdersByCarts
                });
            });
    }, []);

    return (
        <ActiveOrdersContext.Provider value={{state, handleUpdateProof}}>
            {children}
        </ActiveOrdersContext.Provider>
    );
}

const useActiveOrdersContext = () => {
    const context = React.useContext(ActiveOrdersContext);
    if (context === undefined) {
        throw new Error('useActiveOrdersContext must be used within a ActiveOrdersProvider');
    }
    return context;
};

export {ActiveOrdersContextProvider, useActiveOrdersContext};
